import React from 'react';
import { graphql } from 'gatsby';
import SinglePost from '../components/single-post';
import HighlightedPosts from '../components/highlighted-posts/fr';

const FrancaisPost = (props) => (
  <SinglePost
    {...props.data.post}
    blogPage={props.data.blogPage}
    lang="fr"
  >
    <HighlightedPosts />
  </SinglePost>
);

export default FrancaisPost;

export const postQuery = graphql`
  query FrancaisBlogPostByPath($path: String!, $blogPageId: String!) {
    blogPage: strapiPage(id: { eq: $blogPageId }) {
      id
      afterContentSections {
        ...PagebuilderSections
      }
    }
    post: wpFrancaisPost(uri: { eq: $path }) {
      path: uri
      title
      date
      content
      excerpt
      author {
        node {
          name
        }
      }
      featuredImage {
        node {
          mediaDetails {
            height
            width
          }
          mediaItemUrl
          gatsbyImage(
            layout: CONSTRAINED
            placeholder: BLURRED
            width: 1200
            quality: 80
          )
        }
      }
    }
  }
`;
